import api from "api";
import { ReferralTrackingParams } from "./types";
import buildQueryString from "./buildQueryString";

const exportReferralsCsv = async (params: ReferralTrackingParams): Promise<void> => {
  const qs = buildQueryString(params);
  const response = await api.call(`/uk/referral_tracking/export${qs}`);
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `referral-tracking-${new Date().toISOString().split("T")[0]}.csv`;
  a.click();
  window.URL.revokeObjectURL(url);
};

export default exportReferralsCsv;
